import CopyButtonLabel from './CopyButtonLabel';

export default CopyButtonLabel;
